<template>
  <div class="animated fadeIn">

    <b-card>
      <b-row>
        <img src="img/brand/portadaplataforma.png" alt="Kiwa dashboard" style="width: 100%">
      </b-row>
    </b-card>
  </div>
</template>

<script>

export default {
  name: 'dashboard',
  data: function () {
    return {
    }
  },
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
